import 'bootstrap/dist/css/bootstrap.min.css';
import "./src/styles/global.css"